;(function () {
  angular
    .module('contrast.servers')
    .controller('ModalDeleteInstanceCtrl', ModalDeleteInstanceCtrl)

  function ModalDeleteInstanceCtrl(
    $scope,
    $uibModalInstance,
    logger,
    ServerFactory,
    ErrorService,
    server,
    orgUuid
  ) {
    'ngInject'

    $scope.server = server
    $scope.Modal = { deletetraces: false }
    $scope.orgUuid = orgUuid

    $scope.changeDeleteTracesValue = function (deletetraces) {
      $scope.deletetraces = deletetraces
    }

    $scope.ok = function () {
      var form = $scope.Modal
      ServerFactory.deleteServer(server.server_id, form.deletetraces).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $uibModalInstance.close(form.deletetraces)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
